import React, { useCallback } from 'react';
import { defineMessage } from 'react-intl';
import { useDispatch } from 'react-redux';

import Button from 'ui-components/components/button';
import { launchEnterpriseChat } from '../../../store/app-header/app-header.actions';
import { useChatSupportBasicFeatureGate } from '../../../feature-gates/use-chat-support-basic-feature-gate';

const LinkToSuncoChat = ({ children }) => {
  const { isFeatureEnabled } = useChatSupportBasicFeatureGate();
  const dispatch = useDispatch();
  const handleClick = useCallback(() => {
    dispatch(launchEnterpriseChat());
  }, [dispatch]);

  return isFeatureEnabled ? (
    <Button onClick={handleClick} theme='link'>
      {children}
    </Button>
  ) : (
    children
  );
};

const messageValues = {
  link: (chunks) => <LinkToSuncoChat>{chunks}</LinkToSuncoChat>,
};

// TODO: At time of writing, FedEx (wallet) is the only provider that requires prior approval and will hit this error message
// The challenge was resolving the fulfillmentPlanId in a label batch error
// to a Carrier/Provider name in a non-hook function
// finding all of the potential callers and wiring down state
export const message = defineMessage({
  description: 'Error message saying the selected provider service is not available to use as it is pending approval',
  defaultMessage: 'Selected carrier services are pending approval. Need help? <link>Contact support</link>.',
  id: 'ht0xGZ',
});

export const walletProviderApprovalPendingMessageBuilder = () => {
  return {
    ...message,
    values: messageValues,
  };
};
